import { type PrintPreferences } from '../types/preferences.type';
import { PrintAssetType, PrintColor, PrintInitiation } from '../types/print.type';

export const EMPTY_PREFERENCES: PrintPreferences = {
  [PrintAssetType.Manifest]: {
    color: PrintColor.BlackAndWhite,
    initiation: PrintInitiation.DownloadPdf,
    printerName: '',
  },
  [PrintAssetType.PickList]: {
    color: PrintColor.BlackAndWhite,
    initiation: PrintInitiation.DownloadPdf,
    printerName: '',
  },
  [PrintAssetType.ShippingLabel]: {
    color: PrintColor.BlackAndWhite,
    initiation: PrintInitiation.ClickToPrint,
    printerName: '',
  },
};
